var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-simple-table',{scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('tbody',[_c('tr',[_c('th',[_vm._v("Náhled smlouvy")]),_c('th',[_c('a',{attrs:{"href":_vm.contractUrl}},[_c('v-icon',[_vm._v("mdi-file")])],1)])])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }